export default (axios) => ({
    getAll: (params) => axios.get('u/settings?origin=benhvien16a.com', { params }).then((_) => _.data),
});
